export interface OneValueMeasurement {
  value: number;
  is_healthy: "healthy" | "unhealthy" | "warning";
  date: string;
}

export interface LastMeasurements {
  blood_glucose: OneValueMeasurement | null;
  blood_oxygen_saturation: OneValueMeasurement | null;
  blood_pressure_systolic: OneValueMeasurement | null;
  blood_pressure_diastolic: OneValueMeasurement | null;
  body_temperature: OneValueMeasurement | null;
  respiratory_rate: OneValueMeasurement | null;
  body_weight: OneValueMeasurement | null;
  heart_rate: OneValueMeasurement | null;
  heart_rate_variability: OneValueMeasurement | null;
  walking_steps: OneValueMeasurement | null;
}

export const getLastMeasurements = async (
  patientId: number,
): Promise<LastMeasurements> => {
  const { api } = await import("./axios");

  const response = await api.get<{ data: LastMeasurements }>(
    `/measurements/last?patient_id=${patientId}`,
  );

  return response.data.data;
};
